module.exports = __webpack_public_path__ + "img/12exp.cd52d938.jpg";